import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import '../styles/thankYou.css';

export default function ThankYouPage() {
  const heading = useRef(null);

  useEffect(() => {
    document.title = 'Thank You | Jos Immigration Law';
    window.scrollTo({ top: 0, behavior: 'instant' });
    heading.current?.focus({ preventScroll: true });
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, follow';
    document.head.appendChild(robots);
    return () => { robots.remove(); };
  }, []);

  return <div className="jos-thank-you" data-testid="thank-you-page">
    <header className="jos-thank-you-header">
      <div className="jos-thank-you-header-inner">
        <Link to="/" className="jos-thank-you-logo-link" data-testid="thank-you-logo-link" aria-label="Jos Immigration Law homepage">
          <img src="/brand/jos-approved-reversed-trimmed.png" alt="Jos Immigration Law" data-testid="thank-you-logo" />
        </Link>
      </div>
    </header>

    <main className="jos-thank-you-main" data-testid="thank-you-main" aria-labelledby="thank-you-heading">
      <img className="jos-thank-you-background" src="/images/consultation-background.webp" alt="" aria-hidden="true" data-testid="thank-you-background-image" />
      <div className="jos-thank-you-content">
        <span className="jos-thank-you-check" aria-hidden="true"><Check size={30} strokeWidth={1.7} /></span>
        <p className="jos-thank-you-eyebrow" data-testid="thank-you-status">ENQUIRY RECEIVED</p>
        <h1 id="thank-you-heading" ref={heading} tabIndex={-1} data-testid="thank-you-heading">Thank you for your enquiry.</h1>
        <p className="jos-thank-you-message" data-testid="thank-you-message">Our team will reach out to you as soon as possible.</p>
        <div className="jos-thank-you-actions">
          <Button asChild className="jos-thank-you-button jos-thank-you-primary">
            <Link to="/" data-testid="thank-you-home-button">Return to homepage <ArrowRight size={18} aria-hidden="true" /></Link>
          </Button>
          <Button asChild variant="outline" className="jos-thank-you-button jos-thank-you-secondary">
            <a href="tel:+19498836002" data-testid="thank-you-call-button"><Phone size={17} aria-hidden="true" />949-883-6002</a>
          </Button>
        </div>
      </div>
    </main>

    <footer className="jos-thank-you-footer">
      <p data-testid="thank-you-firm-location">Jos Immigration Law <span aria-hidden="true">·</span> Orange County, California</p>
      <p data-testid="thank-you-legal-note">Submitting this form does not create an attorney-client relationship.</p>
    </footer>
  </div>;
}